import React, { useEffect, useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import { invokeApi, S3baseUrl } from "../../../bl_libs/ApiCalling";
import { withRouter } from "react-router-dom";
import { FormControl, IconButton, InputLabel, Select } from "@material-ui/core";
import { CKEditor, USAStates } from "../../../components";
import { states } from "../../../ui_libs/Data/data";
import { Editor } from "@tinymce/tinymce-react";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#c4314b",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  txt: {
    color: "black",
  },
  alert: {
    width: "100%",
  },
  swtch: {
    marginTop: "20px",
  },
}));

function EditDocument(props) {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);

  const [errorMessage, setErrorMessage] = useState(false);

  const [emailData, setEmailData] = useState(true);

  const editorRef = useRef(null);

  const handleChange = (e) => {
    setEmailData({ ...emailData, [e.target.name]: e.target.value });
  };

  const getEditorData = () => {
    if (editorRef.current) {
      const value = editorRef.current.getContent();
      return value;
    }
    return "";
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    UpdateDocument();
  };

  const UpdateDocument = () => {
    const editor_data = getEditorData();

    if (!editor_data) {
      setErrorMessage("Email template is required.");
      return;
    }

    const postData = {
      title: emailData.title,
      type: emailData.type,
      email_subject: emailData.email_subject,
      email_message: editor_data,
      is_active: `${emailData.is_active}`,
    };

    setIsLoading(true);

    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/edit_email_template/" + props.match.params.id,
      method: "PUT",
      postData: postData,
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        handleBack();
      } else {
        setErrorMessage(res.message);
        setIsLoading(false);
      }
    });
  };

  const FetchDocument = () => {
    const token = localStorage.getItem("token");
    let requestObj = {
      path: "/api/admin/detail_email_template/" + props.match.params.id,
      method: "GET",
      headers: {
        "x-sh-auth": token,
      },
    };
    invokeApi(requestObj).then((res) => {
      //console.log(res, "RESPONSE");
      if (res.code == 200) {
        setEmailData(res.emailtemplate);
        setIsLoading(false);
      } else {
      }
    });
  };

  function example_image_upload_handler(blobInfo, success, failure, progress) {
    let requestObj = {
      path: "/app_api/upload_s3_file",
      method: "POST",
      headers: {},
    };

    let _formData = new FormData();
    _formData.append("upload_file", blobInfo.blob());
    requestObj["postData"] = _formData;
    invokeApi(requestObj).then((res) => {
      console.log(res, "IMAGE UPLOADER");
      if (res.code === 200) {
        success(S3baseUrl + res.file_url);
      } else {
        failure(res.message);
      }
    });
  }

  const handleBack = () => {
    props.history.goBack();
  };

  useEffect(() => {
    FetchDocument();
  }, []);
  if (isLoading) {
    return (
      <div className="Circular-Progress">
        <CircularProgress color="primary" />
      </div>
    );
  }
  return (
    <div>
      <Container component="main" maxWidth="md">
        <IconButton
          className="backarrow pointer-point mt-2"
          onClick={handleBack}
          style={{ outline: "none" }}
        >
          <ArrowBackIcon color="primary"></ArrowBackIcon>
        </IconButton>
        <CssBaseline />
        <div className={classes.paper}>
          <Typography className={classes.txt} component="h1" variant="h5">
            Edit Email Template
          </Typography>
          {errorMessage && (
            <Alert className={classes.alert} severity="error">
              {errorMessage}
            </Alert>
          )}
          <form className={classes.form} onSubmit={handleSubmit}>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="type"
                  value={emailData.type}
                  // onChange={handleChange}
                  label="Email Type"
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="title"
                  value={emailData.title}
                  onChange={handleChange}
                  label="Email Title"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  name="email_subject"
                  value={emailData.email_subject}
                  onChange={handleChange}
                  name="description"
                  label="Email Subject"
                  id="description"
                />
              </Grid>

              <Grid item xs={12}>
                <label htmlFor="email" className="overline dark-grey-color">
                  Email Template
                </label>
                <Editor
                  apiKey="o74is8fu0fhdzefwd4dz4n1h0g1hhju79y6smh63lyg6gykh"
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  initialValue={emailData.email_message}
                  init={{
                    images_upload_handler: example_image_upload_handler,
                    height: 500,
                    menubar: true,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | " +
                      "removeformat | help",
                    content_style:
                      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                >
                  Update Email Template
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </div>
  );
}
export default withRouter(EditDocument);
